import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { getErrorMessage } from '../../utils/helper';

const NOTIFICATION_ENDPOINT = '/notification';

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async ({ page = 1, limit = 10, isRead = 'all', startDate = null, endDate = null }, { rejectWithValue }) => {
    try {      
      let url = `${NOTIFICATION_ENDPOINT}?page=${page}&limit=${limit}`;
      
      if (isRead !== 'all') {
        url += `&isRead=${isRead === 'read'}`;
      }
      
      if (startDate) {
        url += `&startDate=${startDate.toISOString()}`;
      }
      
      if (endDate) {
        url += `&endDate=${endDate.toISOString()}`;
      }

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
        return rejectWithValue(getErrorMessage(error ,'Failed to fetch notifications'));
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  'notifications/markAsRead',
  async (notificationId, { rejectWithValue }) => {
    try {
      await axiosInstance.patch(`${NOTIFICATION_ENDPOINT}/view`, { notificationIds: [notificationId] });
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to mark notification as read'));
    }
  }
);